const CHARMAP = {
  Ã¡: 'a',
  Ã: 'A',
  Ã: 'A',
  Ã : 'a',
  Ä: 'A',
  Ä: 'a',
  áº®: 'A',
  áº¯: 'a',
  áº±: 'a',
  áº°: 'A',
  áº´: 'A',
  áºµ: 'a',
  áº³: 'a',
  áº²: 'A',
  Ã¢: 'a',
  Ã: 'A',
  áº¥: 'a',
  áº¤: 'A',
  áº§: 'a',
  áº¦: 'A',
  Ç: 'a',
  Ç: 'A',
  Ã¥: 'a',
  Ã: 'A',
  Çº: 'A',
  Ç»: 'a',
  Ã¤: 'a',
  Ã: 'A',
  aÌ: 'a',
  AÌ: 'A',
  Ã: 'A',
  Ã£: 'a',
  AÌ§: 'A',
  aÌ§: 'a',
  Ä: 'A',
  Ä: 'a',
  Ä: 'a',
  Ä: 'A',
  È: 'a',
  È: 'A',
  È: 'a',
  È: 'A',
  áº¶: 'A',
  áº·: 'a',
  Ã¦: 'a', // ae
  Ã: 'A', // AE
  Ç¼: 'A', // AE
  Ç½: 'a', // ae
  bÌ: 'b',
  BÌ: 'B',
  bÌ§: 'b',
  BÌ§: 'B',
  Ä: 'c',
  Ä: 'C',
  cÌ: 'c',
  CÌ: 'C',
  Ä: 'c',
  Ä: 'C',
  Ä: 'c',
  Ä: 'C',
  Ä: 'c',
  Ä: 'C',
  Ã: 'C',
  Ã§: 'c',
  á¸: 'C',
  á¸: 'c',
  ÄÌ£: 'c',
  ÄÌ£: 'C',
  Ä: 'D',
  Ä: 'd',
  á¸: 'd',
  á¸: 'D',
  Ä: 'd',
  Ä: 'D',
  Ã: 'D',
  Ã°: 'd',
  Ã: 'E',
  Ã©: 'e',
  Ã: 'E',
  Ã¨: 'e',
  Ä: 'E',
  Ä: 'e',
  Ãª: 'e',
  Ã: 'E',
  áº¾: 'E',
  áº¿: 'e',
  á»: 'e',
  á»: 'E',
  ÃÌ: 'E',
  ÃªÌ: 'e',
  Ä: 'E',
  Ä: 'e',
  Ã«: 'e',
  Ã: 'E',
  eÌ: 'e',
  EÌ: 'E',
  Ä: 'E',
  Ä: 'e',
  È¨: 'E',
  È©: 'e',
  á¸: 'e',
  á¸: 'E',
  Ä: 'E',
  Ä: 'e',
  Ä: 'E',
  Ä: 'e',
  á¸: 'E',
  á¸: 'e',
  á¸: 'E',
  á¸: 'e',
  È: 'E',
  È: 'e',
  È: 'E',
  È: 'e',
  ÉÌ§: 'e',
  ÆÌ§: 'E',
  fÌ: 'f',
  FÌ: 'F',
  Æ: 'f',
  Çµ: 'g',
  Ç´: 'G',
  Ä: 'g',
  Ä: 'G',
  Ä: 'G',
  Ä: 'g',
  Ç§: 'g',
  Ç¦: 'G',
  Ä : 'G',
  Ä¡: 'g',
  Ä£: 'g',
  Ä¢: 'G',
  Ä¤: 'H',
  Ä¥: 'h',
  È: 'h',
  È: 'H',
  á¸©: 'h',
  á¸¨: 'H',
  Ä§: 'h',
  Ä¦: 'H',
  á¸«: 'h',
  á¸ª: 'H',
  Ã­: 'i',
  Ã: 'I',
  Ã: 'I',
  Ã¬: 'i',
  Ä¬: 'I',
  Ä­: 'i',
  Ã: 'I',
  Ã®: 'i',
  Ç: 'i',
  Ç: 'I',
  Ã¯: 'i',
  Ã: 'I',
  á¸¯: 'i',
  á¸®: 'I',
  IÌ: 'I',
  iÌ: 'i',
  Ä©: 'i',
  Ä¨: 'I',
  Ä°: 'I',
  IÌ§: 'I',
  iÌ§: 'i',
  Ä®: 'I',
  Ä¯: 'i',
  Ä«: 'i',
  Äª: 'I',
  È: 'i',
  È: 'I',
  È: 'i',
  È: 'I',
  Ä³: 'i', // ij
  Ä²: 'I', // IJ
  Ä±: 'i',
  ÆÌ§: 'I',
  É¨Ì§: 'i',
  Äµ: 'j',
  Ä´: 'J',
  Ç°: 'j',
  JÌ: 'J',
  á¸°: 'K',
  á¸±: 'k',
  kÌ: 'k',
  KÌ: 'K',
  Ç©: 'k',
  Ç¨: 'K',
  Ä·: 'k',
  Ä¶: 'K',
  Ä¹: 'L',
  Äº: 'l',
  Ä½: 'L',
  Ä¾: 'l',
  Ä¼: 'l',
  Ä»: 'L',
  Å: 'l',
  Å: 'l',
  Ä¿: 'L',
  Å: 'l',
  á¸¾: 'M',
  á¸¿: 'm',
  mÌ: 'm',
  MÌ: 'M',
  mÌ: 'm',
  MÌ: 'M',
  MÌ§: 'M',
  mÌ§: 'm',
  Å: 'N',
  Å: 'n',
  Ç¸: 'N',
  Ç¹: 'n',
  nÌ: 'n',
  NÌ: 'N',
  Å: 'N',
  Å: 'n',
  Ã±: 'n',
  Ã: 'N',
  Å: 'N',
  Å: 'n',
  Ã³: 'o',
  Ã: 'O',
  Ã: 'O',
  Ã²: 'o',
  Å: 'O',
  Å: 'o',
  Ã: 'O',
  Ã´: 'o',
  á»: 'o',
  á»: 'O',
  á»: 'o',
  á»: 'O',
  Ç: 'O',
  Ç: 'o',
  Ã: 'O',
  Ã¶: 'o',
  Å: 'o',
  Å: 'O',
  Ã: 'O',
  Ãµ: 'o',
  á¹: 'o',
  á¹: 'O',
  Ã: 'O',
  Ã¸: 'o',
  Ç¾: 'O',
  Ç¿: 'o',
  oÌ§: 'o',
  OÌ§: 'O',
  Å: 'O',
  Å: 'o',
  á¹: 'o',
  á¹: 'O',
  á¹: 'o',
  á¹: 'O',
  È: 'o',
  È: 'O',
  È: 'o',
  È: 'O',
  Æ¡: 'o',
  Æ : 'O',
  Å: 'o', // oe
  Å: 'O', // OE
  á¹: 'p',
  á¹: 'P',
  pÌ: 'p',
  PÌ: 'P',
  PÌ: 'P',
  pÌ: 'p',
  QÌ: 'Q',
  qÌ: 'q',
  QÌ§: 'Q',
  qÌ§: 'q',
  Å: 'r',
  Å: 'R',
  rÌ: 'r',
  RÌ: 'R',
  Å: 'R',
  Å: 'r',
  Å: 'r',
  Å: 'R',
  ÅÌ©: 'R',
  ÅÌ©: 'r',
  È: 'r',
  È: 'R',
  È: 'R',
  È: 'r',
  Å: 'S',
  Å: 's',
  á¹¤: 'S',
  á¹¥: 's',
  Å: 'S',
  Å: 's',
  Å¡: 's',
  Å : 'S',
  á¹¦: 'S',
  á¹§: 's',
  Å: 's',
  Å: 'S',
  È: 's',
  È: 'S',
  Å¿: 's',
  TÌ: 'T',
  tÌ: 't',
  Å¤: 'T',
  Å¥: 't',
  Å£: 't',
  Å¢: 'T',
  È: 'T',
  È: 't',
  Å§: 't',
  Å¦: 'T',
  Ã: 'U',
  Ãº: 'u',
  Ã¹: 'u',
  Ã: 'U',
  Å­: 'u',
  Å¬: 'U',
  Ã: 'U',
  Ã»: 'u',
  Ç: 'u',
  Ç: 'U',
  Å®: 'U',
  Å¯: 'u',
  Ã¼: 'u',
  Ã: 'U',
  Ç: 'u',
  Ç: 'U',
  Ç: 'U',
  Ç: 'u',
  Ç: 'u',
  Ç: 'U',
  Ç: 'u',
  Ç: 'U',
  Å°: 'U',
  Å±: 'u',
  Å©: 'u',
  Å¨: 'U',
  á¹¸: 'U',
  á¹¹: 'u',
  uÌ§: 'u',
  UÌ§: 'U',
  Å²: 'U',
  Å³: 'u',
  Åª: 'U',
  Å«: 'u',
  È: 'u',
  È: 'U',
  È: 'U',
  È: 'u',
  Æ°: 'u',
  Æ¯: 'U',
  á»©: 'u',
  á»¨: 'U',
  á»«: 'u',
  á»ª: 'U',
  VÌ: 'V',
  vÌ: 'v',
  vÌ: 'v',
  VÌ: 'V',
  áº: 'W',
  áº: 'w',
  áº: 'W',
  áº: 'w',
  Åµ: 'w',
  Å´: 'W',
  WÌ: 'W',
  wÌ: 'w',
  xÌ: 'x',
  XÌ: 'X',
  XÌ: 'X',
  xÌ: 'x',
  xÌ: 'x',
  XÌ: 'X',
  XÌ§: 'X',
  xÌ§: 'x',
  Ã: 'Y',
  Ã½: 'y',
  á»²: 'Y',
  á»³: 'y',
  yÌ: 'y',
  YÌ: 'Y',
  Å¶: 'Y',
  Å·: 'y',
  yÌ: 'y',
  YÌ: 'Y',
  Ã¿: 'y',
  Å¸: 'Y',
  Åº: 'z',
  Å¹: 'Z',
  Å½: 'Z',
  Å¾: 'z',
  Å»: 'Z',
  Å¼: 'z',
  ZÌ§: 'Z',
  zÌ§: 'z',
};

const DIACRITICS = new RegExp(Object.keys(CHARMAP).join('|'), 'g');

export function normalizeDiacritics(text: string): string {
  if (!text || text === '') return;
  return text.replace(DIACRITICS, match => CHARMAP[match]);
}
